import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  HeartIcon,
  ClipboardDocumentCheckIcon,
  CalendarIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

const featureIcons = {
  prayer: HeartIcon,
  attendance: ClipboardDocumentCheckIcon,
  events: CalendarIcon,
  chat: ChatBubbleLeftRightIcon
};

const healthColors = {
  green: { bg: 'bg-emerald-50', border: 'border-emerald-200', icon: 'text-emerald-600' },
  yellow: { bg: 'bg-amber-50', border: 'border-amber-200', icon: 'text-amber-600' },
  red: { bg: 'bg-red-50', border: 'border-red-200', icon: 'text-red-600' }
};

const healthEmoji = { green: '🟢', yellow: '🟡', red: '🔴' };

export default function FeatureHealthCard({
  feature,
  health,
  adoption,
  metricType = 'adoption',
  usageLabel,
  effectiveness,
  effectivenessLabel,
  organizationId,
  campusId,
  groupId,
  onClick
}) {
  const navigate = useNavigate();
  const Icon = featureIcons[feature] || HeartIcon;
  const colors = healthColors[health] || healthColors.yellow;

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Build query params preserving all current filters
      const params = new URLSearchParams();
      if (organizationId) params.set('organizationId', organizationId);
      if (campusId) params.set('campusId', campusId);
      if (groupId) params.set('groupId', groupId);
      const queryString = params.toString();
      navigate(`/feature-analytics/${feature}${queryString ? `?${queryString}` : ''}`);
    }
  };

  const formatPercent = (value) => {
    if (typeof value === 'number') {
      return `${(value * 100).toFixed(0)}%`;
    }
    return value;
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full text-left p-4 rounded-xl border-2 transition-all hover:shadow-md ${colors.bg} ${colors.border}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="text-lg">{healthEmoji[health]}</span>
          <span className="font-semibold capitalize text-slate-800">{feature}</span>
        </div>
        <Icon className={`h-5 w-5 ${colors.icon}`} />
      </div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-slate-600">{metricType === 'participation' ? 'Participation' : 'Adoption'}</span>
          <span className="font-medium text-slate-800">{formatPercent(adoption)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-600">Usage</span>
          <span className="font-medium text-slate-800">{usageLabel}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-600">Effectiveness</span>
          <span className="font-medium text-slate-800">
            {effectivenessLabel || formatPercent(effectiveness)}
          </span>
        </div>
      </div>
    </button>
  );
}
